var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "8 12 32 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.8 14.1 11.9 23c-1.6.6-1.6 1.6-.3 2l5.9 1.8 2.3 7c.3.8 0 1.1.7 1.1.5 0 .7-.2 1-.5l3.5-3.4 7.2 5.3c1.3.7 2.3.3 2.6-1.2L37.4 16c.4-1.6-.6-2.3-1.7-1.9l-.9 0zM19.4 28.7l-.3-4.8 12.2-7.7c.5-.3 1-.1.6.2L19.4 28.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramPlane);
export default __webpack_public_path__ + "static/media/telegram-plane.468a36f4adc0573a2ef864258f50a241.svg";
export { ForwardRef as ReactComponent };